import MainContext from './contexts/MainContext'
import { lazy, useContext, useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom'
import { AUTH_USER_SUCCESS, LOGOUT_USER, PUSH_ROUTES, PUSH_USER_ROUTES } from './reducers/types'
import { getRoutesBasedOnToken } from './helpers/getRoutes'
import SuccessMessageSent from './components/Alerts/SuccessMessage'

const LoginPage = lazy(() => import('./pages/Login'))
const DashBoardPage = lazy(() => import('./pages/Dashboard'))
const RecoveryPassword = lazy(() => import('./pages/RecoverPassword'))
const RegisterNewPassword = lazy(() => import('./pages/RegisterNewPassword'))
const ValidateEmail = lazy(() => import('./pages/ValidateEmail'))
const Privacy = lazy(() => import('./pages/privacy'))
const Home = lazy(() => import('./pages/Home'))
const Plans = lazy(() => import('./pages/Plans'))
const Materials = lazy(() => import('./pages/Materials'))
const SelectedMaterials = lazy(() => import('./pages/SelectedMaterials'))
const MaterialsDetails = lazy(() => import('./pages/MaterialsDetails'))
const ProjectStep1 = lazy(() => import('./containers/v1/step_1'))
const SelectedMaterialsV1 = lazy(() => import('./pages/SelectedMaterials_v1'))
const Materialsv1 = lazy(() => import ('./pages/Materials_v1'))
const BudgetLink = lazy(() => import('./pages/BudgetLink'))
const FlowEdit = lazy(() => import('./pages/FlowEdit'))
const Favorites = lazy(() => import('./pages/Favorites'))

const Routers = () => {

    const navigate = useNavigate()
    const locations = useLocation()

    const { 
        user: { state: userState, dispatch },
        config: { state: configState, dispatch: configDispatch }, 
        localStorage 
    } = useContext(MainContext)

    const userToken = localStorage.getToken()

    useEffect(() => {

        const validateToken = async () => {
            try {

                const token = await localStorage.getLocalStorageToken()

                if (token && !userState.isAuthenticated) {

                    const userRoutes = getRoutesBasedOnToken({ token: userToken, group: 'dashboard', navigate: navigate })

                    dispatch({ type: AUTH_USER_SUCCESS, payload: token })
                    
                    configDispatch({ type: PUSH_ROUTES, payload: userRoutes })

                    configDispatch({ type: PUSH_USER_ROUTES, payload: token })

                } else if (!token && userState.isAuthenticated) {
                    dispatch({ type: LOGOUT_USER })
                    localStorage.removeToken()
                    navigate('/')
                }

            } catch (err) {
                dispatch({ type: LOGOUT_USER })
                localStorage.removeToken()
                navigate('/')
            }    
        }

        validateToken()
        
    }, [locations.pathname, localStorage, dispatch, userState.isAuthenticated, navigate, configDispatch, userToken])

    return (
        <Routes>

            <Route path="/" element={<Home navigate={navigate} /> } />
            <Route path="/login" element={<LoginPage navigate={navigate} /> } />
            <Route path="/recovery/password" element={<RecoveryPassword navigate={navigate} /> } />
            <Route path="/register/password" element={<RegisterNewPassword navigate={navigate} /> } />
            <Route path="/validate/email" element={<ValidateEmail navigate={navigate} />} />
            <Route path="/terms/privacy" element={<Privacy />} />
            <Route path="/plans" element={<Plans navigate={navigate}  />} />
            <Route path="/materials" element={<Materials navigate={navigate}  />} />
            <Route path="/materials/selected" element={<SelectedMaterials navigate={navigate} />} />
            <Route path="/materials/favorites" element={<Favorites navigate={navigate} />}  />
            <Route path="/materials/details" element={<MaterialsDetails navigate={navigate} />} />
            <Route path="/project/v1" element={<ProjectStep1 navigate={navigate} />} />
            <Route path="/v1/materials/selected" element={<SelectedMaterialsV1 navigate={navigate} />} />
            <Route path="/v1/materials" element={<Materialsv1 navigate={navigate} />} />
            <Route path="/p/:token" element={<BudgetLink navigate={navigate} />} />
            <Route path="/v1/project/success" element={<SuccessMessageSent navigate={navigate} />} />
            {/* <Route path="/marbles/map" element={<Maps navigate={navigate} />} /> */}
            <Route path="/flow/:id/code/:password" element={<FlowEdit navigate={navigate} />} />
            <Route path="dashboard" element={ userToken ? <DashBoardPage navigate={navigate} /> : <Navigate to="/" /> }>
                { configState.routes.length > 0 && configState.routes }
            </Route>
            <Route path="*" element={<Home navigate={navigate} />} />
        </Routes>
    )

}

export default Routers